


import apply from './apply';
import { IPatch } from './interface';
import storage from './storage';

const exports: IPatch = {
    apply,
    storage,
};

export default exports

